import Marquee from "react-fast-marquee";

const words = [
  "Legacy Marketing",
  "Crafted with Trust",
  "Designed for Legacy",
  "Not Seen — Felt",
  "Storytelling",
  "Presence · Content · IPs",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      aria-label="editorial marquee"
      className="relative overflow-hidden border-y border-[#2a1f17] bg-[#140e0a] py-10 md:py-14"
    >
      <Marquee speed={26} gradient={false} pauseOnHover>
        {words.map((w, i) => (
          <span
            key={i}
            className="font-serif-editorial text-[9vw] leading-none text-[#f2ebdd] md:text-[6.4vw]"
          >
            <span className="italic">{w}</span>
            <span className="slash">/</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
